import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { NoticePeriod } from "__generated__/graphql";
import { SelectProps } from "@cofano/cck/Select/Select";

const NoticePeriodSelect = ({ value, onChange, disabled }: Omit<SelectProps<NoticePeriod, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(NoticePeriod)}
			getOptionLabel={option => intl.formatMessage({ id: `CONTRACT_NOTICE_PERIOD_${option}` })}
			value={value}
			onChange={onChange}
			disabled={disabled}
			disableSearch />
	);
};

export default NoticePeriodSelect;
